<template>
  <div class="gongkuanpage">
    <div class="bodybox" :style="{ height: bodyDivHeight + 'px' }">
      <Row :gutter="20">
        <i-col span="6">
          <div class="leftbox" :style="{ height: bodyDivHeight + 'px' }">
            <div class="linehr"></div>
            <Spin v-if="treeLoading" fix>
              <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
              <div>菜单加载中...</div>
            </Spin>
            <Input style="width: 200px" v-model="seachCName" class="tabdiv" placeholder="搜索企业">
              <span slot="append" @click="getZXTreeInfo()"><Icon type="ios-search-outline" /></span>
            </Input>
            <div class="divtreebox">
              <el-tree
                ref="treeBox"
                node-key="keyID"
                :data="treeData"
                :props="defaultProps"
                :highlight-current="true"
                :render-content="renderContentYY"
                @node-click="handleNodeClickZX"
              >
              </el-tree>
            </div>
          </div>
        </i-col>
        <i-col span="18">
          <div class="rightbox" :style="{ height: bodyDivHeight + 'px' }">
            <div class="righttablebox">
              <!-- 时间选择 -->
              <div class="righttimesbox">
                <DatePicker
                  size="small"
                  type="daterange"
                  placement="bottom-end"
                  placeholder="请选择时间"
                  style="width: 220px"
                  :options="historyOptions"
                  v-model="tableTime"
                  @on-change="changeRangeTime(6)"
                />
                <!-- activetimes -->
                <div class="timeboxlist">
                  <div
                    class="timeitem"
                    :class="activeIndex == index ? 'activetimes' : ''"
                    v-for="(item, index) in timesList"
                    :key="index"
                    @click="changeBtnTime(index)"
                  >
                    {{ item.label }}
                  </div>
                </div>
              </div>
              <div class="linehr"></div>
              <div class="tableimgbox">
                <!-- 图表 -->
                <div class="tableimgtit">报警数据</div>
                <div class="chart">
                  <Spin v-if="dataInfoLoading" fix>
                    <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
                    <div>加载中...</div>
                  </Spin>
                  <div ref="gkChart" v-if="dayNullData" />
                  <nullData v-else></nullData>
                </div>
                <div class="linehr"></div>
                <div class="tableimgtit">历史数据</div>
                <div>
                  <!-- 数据表格 -->
                  <i-table width="100%" stripe :loading="tbLoading" :columns="columns" :data="tableList" />
                  <!-- 分页 -->
                  <Page
                    style="margin: 10px 0"
                    show-total
                    :current.sync="page"
                    :page-size-opts="[20, 50, 100, 200, 500]"
                    :page-size="row"
                    :total="total"
                    show-sizer
                    @on-change="onNextPageGK"
                    @on-page-size-change="onPageSizeGK"
                  />
                </div>
              </div>
            </div>
          </div>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import { parseTime } from '@/utils/date.js';
import nullData from '@/components/nullData.vue';
export default {
  components: {
    nullData,
  },
  props: {
    timesList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    bodyDivHeight: {
      type: [String, Number],
      default: '',
    },
    yearName: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      // 判断不能选择的日期
      historyOptions: {
        disabledDate: res => {
          let menuYear = Number(this.yearTime);
          let nowYear = Number(parseTime(res, '{y}'));
          return nowYear != menuYear;
        },
      },
      yearTime: '',
      dayNullData: false,
      dataInfoLoading: false, // 信息加载动画
      tableTime: [],
      activeIndex: 0, // 按钮时间下标
      gkSite_id: '', // 排口id
      defaultProps: {
        // 设置树菜单的接受格式
        children: 'childrens',
        label: 'title',
      },
      treeData: [], // 树菜单数据
      gkChart: '',
      tableList: [], // 表格数据
      page: 1,
      row: 20,
      total: 0,
      treeLoading: false, // 树菜单加载动画
      tbLoading: false, //
      seachCName: '', // 搜索企业名
      zxDataInfo: {},
      /**
       * 【油烟】树菜单使用的render 使用自定义格式 返回对应的样式
       */
      renderContentYY: function (h, { node, data, store }) {
        switch (
          data.level // 判断树菜单层级
        ) {
          case 1: // 第1层 街道显示数量 报警变色
            return (
              <span style="font-size: 14px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );

          case 2: // 第2层 公司需要显示数量 报警变色
            // 判断公司报警状态
            return (
              <span style="font-size: 14px;color:red;">
                <i class={data.icon}></i>
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );

          case 3: // 第3层 排口不需要显示数量 报警变色
            // 判断排口报警状态
            //  <i class={data.icon}></i>
            return (
              <span style="font-size: 14px;color:red;">
                <span style="padding-left: 4px;">{node.label}</span>
              </span>
            );
        }
      },
      columns: [
        // 表格列名
        {
          type: 'index',
          title: '序号',
          align: 'center',
          minWidth: 90,
          indexMethod: row => {
            return row._index + 1 + this.page * this.row - this.row;
          },
        },
        {
          title: '监测名称',
          key: 'cn_name',
          align: 'center',
          minWidth: 250,
        },
        {
          title: '编码',
          key: 'code_name',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '当前值',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let _class = '';
            switch (
              params.row.status // 判断值 设置对应的样式
            ) {
              case 1:
                _class = 'demo-table-info-cell-value';
                break;
              case 2:
                _class = 'demo-table-info-cell-value';
                break;
            }
            return h('span', { class: _class }, params.row.value + params.row.unit); // 值+单位
          },
        },
        {
          title: '状态',
          align: 'center',
          minWidth: 130,
          render: (h, params) => {
            let _status = '';
            let _class = '';
            let iconClass = '';
            switch (
              params.row.status // 判断值 设置对应的样式和文字
            ) {
              case 0:
                _status = '正常';
                break;
              case 1:
                _status = '低于标准值';
                _class = 'demo-table-info-cell-value';
                iconClass = 'demo-table-info-cell-value iconfont icon-down';
                break;
              case 2:
                _status = '高于标准值';
                _class = 'demo-table-info-cell-value';
                iconClass = 'demo-table-info-cell-value iconfont icon-up-copy';
                break;
            }
            return h('div', [h('span', { class: _class }, _status), h('i', { class: iconClass })]);
          },
        },
        {
          title: '监测时间',
          align: 'center',
          fixed: 'right',
          width: 180,
          render: (h, params) => {
            return h('span', this.formatDateTime(params.row.receive_time)); // 格式时间戳
          },
        },
      ],
    };
  },
  watch: {
    yearName(val) {
      this.yearTime = val + '';
      this.getGKTreeInfo();
    },
  },
  mounted() {},
  methods: {
    // 初始化图表
    initEcharts(name, dataList) {
      this.gkChart = echarts.init(this.$refs.gkChart);
      this.gkChart.resize();
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter: res => {
            let info = res[0];
            return info.name + '<br />' + info.marker + info.data + '条';
          },
        },
        xAxis: {
          type: 'category',
          data: name,
          axisLabel: {
            show: true,
            lineHeight: '40',
            textStyle: {
              fontSize: 14, //更改坐标轴文字大小
              color: '#5F788E',
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },

        color: ['#ed4014'],
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dashed', //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 14, //更改坐标轴文字大小
              color: '#5F788E',
            },
          },
        },
        grid: {
          left: '0%',
          right: '4%',
          bottom: '3%',
          top: '20px',
          containLabel: true,
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 1, //这里是坐标轴的宽度
            },
          },
        },
        series: [
          {
            data: dataList,
            type: 'bar',
            barWidth: 40,
            showBackground: false,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)',
            },
          },
        ],
      };
      this.gkChart.setOption(option);
    },
    // 时间段选择
    changeRangeTime(index) {
      console.log(this.tableTime[0]);
      this.activeIndex = index;
      this.getTabelInfo(1);
    },
    // 按钮时间切换
    changeBtnTime(index) {
      this.activeIndex = index;
      this.getTabelInfo(1);
    },
    /**
     * 【在线】树菜单单击事件
     */
    handleNodeClickZX(data) {
      // 如果是第3层 就触发 表格事件
      if (data.level === 3) {
        this.total = 0; // 清空
        this.page = 1; // 初始化 设置第一页
        this.row = 20; // 初始化 20条数据
        this.tableList = [];
        this.gkSite_id = data.gkSite_id; // 设置选中排口Id
        // this.getZXTabelInfo(); // 执行表格数据
        // this.getzxChart(); // 图表
        this.getTabelInfo(1);
      }
    },

    /**
     * 得到【在线】表格数据
     */
    getTabelInfo(page) {
      let api = this.ApiUrl + 'gkData/findDataByTime';
      if (!this.gkSite_id) {
        this.$Message.warning('请选择排口');
        return;
      }
      let params = {
        gkSite_id: this.gkSite_id,
        pageNo: page,
        pageSize: this.row,
        type: this.activeIndex + 1, // 1：7天，2：15天，3：1月，4：近2月，5：近6月
        types: 1, // 0 工况 1油烟  2在线
        startTime: '',
        endTime: '',
      };

      if (this.activeIndex == 6 && this.tableTime && this.tableTime.length) {
        let startTime = parseTime(this.tableTime[0], '{y}-{m}-{d}');
        let endTime = parseTime(this.tableTime[1], '{y}-{m}-{d}');
        params.type = 6;
        params.startTime = startTime;
        params.endTime = endTime;
      } else {
        if (this.activeIndex == 6) {
          params.type = 1;
        }
      }
      this.tbLoading = true; // 开启加载动画
      this.dataInfoLoading = true;
      this.total = 0;
      this.page = page;
      this.tableList = [];
      this.$http
        .get(api, { params })
        .then(res => {
          let info = res.data.extend;
          if (info.news === 0) {
            let name = [];
            let dataList = [];
            if (info.list && info.list.length > 0) {
              let list = info.list;

              for (let i = 0; i < list.length; i++) {
                const element = list[i];
                name.push(element.codeName || '-');
                dataList.push(element.num || 0);
              }
            }

            if (name.length > 0 || dataList.length > 0) {
              this.dayNullData = true;
              this.$nextTick(() => {
                setTimeout(() => {
                  this.initEcharts(name, dataList);
                }, 100);
              });
            } else {
              this.dayNullData = false;
            }
            this.total = info.count; // 总页数
            this.tableList = info.pageInfo; // 表格数据
          }

          this.tbLoading = false; // 关闭加载动画
          this.dataInfoLoading = false;
        })
        .catch(err => {
          this.tbLoading = false; // 关闭加载动画
          this.dataInfoLoading = false;
        });
    },
    onPageSizeGK(e) {
      this.row = e;
      this.getTabelInfo(1);
    },
    onNextPageGK(e) {
      this.getTabelInfo(e);
      // this.getGKTabelInfo(); // 执行表格数据
    },
    // 获取树型菜单
    getGKTreeInfo() {
      const api = this.ApiUrl + 'company/htAllWarnCompany';
      if (!this.yearTime) {
        this.$Message.warning('请选择年份');
        return;
      }
      const data = {
        company_name: this.seachCName || '',
        type: 1, // 0 工况 1油烟  2在线
        time: this.yearTime,
      };
      this.treeLoading = true;
      this.$http
        .post(api, data)
        .then(res => {
          if (res.data.extend.news === 0) {
            this.handleTreeListGK(res.data.extend.pageInfo); // 1.渲染树菜单
          } else {
            this.handleTreeListGK([]);
          }
          this.treeLoading = false; // 开启加载动画
        })
        .catch(err => {
          this.handleTreeListGK([]);
          this.treeLoading = false; // 开启加载动画
        });
    },
    /**
     * 【工况】渲染树菜单 根据树菜单要求处理传入得到list数据
     */
    handleTreeListGK(list) {
      // 处理得到数据 添加上树菜单需要的字段
      for (let i = 0; i < list.length; i++) {
        // 添加1级数菜单 【街道】
        list[i].title = list[i].street_name; // 新添title字段 树菜单显示标题
        list[i].icon = 'icon iconfont icon-quyu'; // 新添icon字段 街道图标
        list[i].level = 1; // 添加层级 当前第1层 用于点击事件判断用
        list[i].keyID = '1' + list[i].street_id; // 添加一个唯一ID 用于展开使用 ；  '1'+ 是为了 1层、2层、3层没有相同的ID
        list[i].childrens = list[i].companyHtWarnFroms; // 添加用于树菜单的childrens子级名

        // 处理2级菜单 判断一下是否有childrens节点
        if (list[i].childrens) {
          // 循环第二级数据 添加数据 【公司】
          for (let j = 0; j < list[i].childrens.length; j++) {
            list[i].childrens[j].title = list[i].childrens[j].company_name; // 新添title字段 树菜单显示标题
            list[i].childrens[j].icon = 'icon iconfont icon-jiudian'; // 新添icon字段 企业图标
            list[i].childrens[j].level = 2; // 添加层级 当前第1层 用于点击事件判断用
            list[i].childrens[j].keyID = '2' + list[i].childrens[j].company_id; // 添加一个唯一ID 用于展开使用 ；  '2'+ 是为了  1层、2层、3层没有相同的ID
            list[i].childrens[j].childrens = list[i].childrens[j].yyDataList; // 添加用于树菜单的childrens子级名

            // 处理3级菜单 判断一下是否有childrens节点
            if (list[i].childrens[j].childrens) {
              // 循环第三级数据 添加数据 【排口】
              for (let k = 0; k < list[i].childrens[j].childrens.length; k++) {
                list[i].childrens[j].childrens[k].title = list[i].childrens[j].childrens[k].gkSite_name; // 新添title字段 树菜单显示标题
                list[i].childrens[j].childrens[k].icon = 'icon iconfont icon-youyanji1'; // 新添icon字段 排口图标
                list[i].childrens[j].childrens[k].level = 3; // 添加层级 当前第1层 用于点击事件判断用
                list[i].childrens[j].childrens[k].keyID = '3' + list[i].childrens[j].childrens[k].gkSite_id; // 添加一个唯一ID 用于展开使用；  '3'+ 是为了  1层、2层、3层没有相同的ID
              }
            }
          }
        }
      }
      this.treeData = list; // 处理好的list赋值树菜单渲染
    },
  },
};
</script>

<style scoped lang="scss">
.gongkuanpage {
  .bodybox {
    margin-top: 15px;
    overflow: hidden;
    .leftbox {
      background: #fff;
      overflow: hidden;
      padding: 0 15px;
      position: relative;
      padding-top: 20px;
      display: flex;
      flex-direction: column;
      .linehr {
        height: 5px;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        background-color: #0062ff;
        border-radius: 8px 8px 0 0;
      }
      .divtreebox {
        flex: 1;
        overflow-y: auto;
        margin-top: 15px;
      }
      // 滚动条宽高
      .divtreebox::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      // 滚动条背景颜色
      .divtreebox::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 5px;
      }
      // 滚动条颜色
      .divtreebox::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }
      // 鼠标移动到滚动条上颜色
      .divtreebox::-webkit-scrollbar-thumb:hover {
        background: rgb(122, 121, 121);
      }
    }
    .rightbox {
      background: #fff;
      height: 100%;
      border-radius: 8px 8px 0 0;
      .righttablebox {
        height: 100%;
        padding: 0 15px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }
      .righttimesbox {
        flex: none;
        display: flex;
        padding-top: 15px;
        align-items: center;
        margin-bottom: 15px;
        .timeboxlist {
          display: flex;
          align-items: center;
          margin-left: 20px;

          .timeitem {
            padding: 5px 9px;
            opacity: 1;
            border-radius: 2px;
            font-size: 12px;
            color: #5f788e;
            border: 1px solid #ebecf2;
            margin-right: 10px;
            line-height: 1em;
            cursor: pointer;
          }
          .timeitem:hover {
            background: #0062ff;
            color: #ffffff;
            border: 1px solid #fff;
            border-radius: 2px;
          }
          .activetimes {
            background: #0062ff;
            color: #ffffff;
            border: 1px solid #fff;
            border-radius: 2px;
          }
        }
      }
      .tableimgbox {
        flex: 1;
        overflow-y: auto;
      }
      // 滚动条宽高
      .tableimgbox::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      // 滚动条背景颜色
      .tableimgbox::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 5px;
      }
      // 滚动条颜色
      .tableimgbox::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }
      // 鼠标移动到滚动条上颜色
      .tableimgbox::-webkit-scrollbar-thumb:hover {
        background: rgb(122, 121, 121);
      }
      .linehr {
        flex: none;
        width: 100%;
        border: 1px solid #e5e6ee;
      }
      .tableimgtit {
        position: relative;
        padding-left: 9px;
        margin-top: 15px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #233c52;
        margin-bottom: 15px;
      }
      .tableimgtit:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 4px;
        height: 16px;
        background: #0062ff;
        transform: translateY(-50%);
      }
      .chart {
        height: 300px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        > div {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
